module.exports = __webpack_public_path__ + "static/car2-29333a4c5fab419cca16ba59d980160b.png";